<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Privéonttrekkingen en -stortingen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als ondernemer kun je geld of goederen in je onderneming inbrengen. Je kunt ook geld of goederen uit de
                onderneming halen voor privégebruik.

                <div class="space10"></div>

                <b>Privéstortingen</b><br/>
                Als je een storting vanuit privé doet, stijgt het vermogen van de onderneming. Maar privéstortingen
                vormen geen ondernemingswinst, omdat het geen zakelijke inkomsten zijn. Bij de fiscale winstberekening
                mag je ze dus buiten beschouwing laten.<br/>
                Voorbeelden van privéstortingen:
                <li class="list">geld dat je stort vanaf een privérekening</li>
                <li class="list">goederen die je vanuit je privévermogen in je onderneming inbrengt (auto, computer
                    enz.)
                </li>

                <div class="space10"></div>

                <b>Privéonttrekkingen</b><br/>
                Privéonttrekkingen zijn uitgaven die je uit het ondernemingsvermogen hebt betaald voor jezelf, of
                goederen die je uit de onderneming haalt voor privégebruik. Privéonttrekkingen verlagen dus het vermogen
                van de onderneming. Maar omdat het geen zakelijke kosten zijn, zijn privéonttrekkingen niet aftrekbaar
                van de ondernemingswinst.
                <div class="space10"></div>
                Naast de privéonttrekking in contanten of in goederen, zijn ook het privégebruik van een auto van de
                onderneming en het privégebruik van de zakelijke woning voorbeelden van privéonttrekkingen.
                <div class="space10"></div>
                <b>Wat is de waarde van de storting/onttrekking?</b><br/>
                In de meeste gevallen gaat je bij een storting of onttrekking uit van de waarde in het economisch
                verkeer. Dat is de waarde die in normale koop- en verkoopsituaties zou gelden. Bij bedrijfsmiddelen
                zoals computers en auto’s is deze waarde vaak redelijk makkelijk te bepalen. Bij onroerende zaken kan de
                WOZ-waarde een goede indicatie zijn.<br/>
                Sommige privéonttrekkingen die je doet uit de voorraad van de onderneming, mag je waarderen tegen
                inkoopprijs.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Onttrekking privégebruik auto - algemeen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Rijdt de ondernemer in een (bestel)auto van de onderneming? En gebruikt hij deze auto ook privé? Dan
                telt je voor dat privégebruik een bedrag bij de winst. Dit bedrag is maximaal het bedrag van de
                autokosten. Het bedrag dat je bijtelt, hangt af van de waarde van de auto en het moment waarop de
                ondernemer de auto voor de 1e keer in gebruik neemt.

                <div class="space10"></div>

                <b>Bijtelling</b><br/>
                De bijtelling is een percentage van de cataloguswaarde van de auto. Voor een auto op waterstof geldt een
                speciaal tarief. De bijtelling is mede afhankelijk van de CO2-uitstoot van de auto. De uitstootgrenzen
                worden ieder jaar opnieuw vastgesteld.<br/>
                De percentages voor {{ this.year }} vind je onderstaand.
                <div class="space10"></div>

                <snelstart-ui-button size="small" type="secondary" iconRight="arrow-up-right-from-square">
                    <div *ngIf="this.year == 2024">
                        <a target="_blank"
                           href="https://www.belastingdienst.nl/bibliotheek/handboeken/html/boeken/FISIN2024/fiscale_informatie_2024-winst_uit_onderneming.html#_a5c1308b-7404-4615-ac57-e8985d4b36de"
                        >
                            Informatie over privégebruik auto 2024
                        </a>
                    </div>
                    <div *ngIf="this.year == 2025">
                        <a target="_blank"
                           href="https://www.belastingdienst.nl/wps/wcm/connect/fisin/fisin2025/winst_uit_onderneming#_a5c1308b-7404-4615-ac57-e8985d4b36de"
                        >
                            Informatie over privégebruik auto 2025
                        </a>
                    </div>

                </snelstart-ui-button>

                <div class="space10"></div>
                Alleen als de ondernemer op jaarbasis niet meer dan 500 kilometer privé rijdt, hoeft hij niets bij te
                tellen. Je moet dit wel kunnen bewijzen, bijvoorbeeld met een rittenregistratie. Woon-werkverkeer valt
                ook onder zakelijke kilometers.
                <div class="space10"></div>
                Voor bepaalde bestelauto's geldt een andere regeling.<br/>
                Voor zuinige (bestel)auto's en voor nulemissieauto's geldt een lagere bijtelling tijdens de eerste 60
                maanden na de eerste
                tenaamstelling. Daarna geldt een ander tarief.<br/>
                Is de auto ouder dan 60 maanden en is het een nulemissieauto, dan is er ook een speciaal tarief.<br/>
                <div class="space10"></div>
                Je moet kunnen bewijzen dat de auto voldoet aan de specificaties voor zuinige auto's en
                nulemissieauto's.<br/>

                <div class="space10"></div>
                <b>Bijzondere situaties</b><br/>
                Soms geldt voor het privégebruik van de auto van de onderneming een afwijkende berekening in plaats van
                de normale berekening. Bijvoorbeeld als je een bestelauto hebt die (bijna) uitsluitend geschikt is voor
                goederenvervoer, of als je een personen- of bestelauto hebt die ouder is dan 15 jaar.
                <div class="space10"></div>
                Een andere bijzondere situatie is dat het privégebruik hoger is dan het bedrag dat je normaal gesproken
                moet bijtellen.
                <div class="space10"></div>

                <b>Deel van het jaar een auto van de onderneming</b><br/>
                Heeft de ondernemer maar een deel van het jaar een auto van de onderneming? Dan bereken je het bedrag
                dat bijgeteld
                wordt over dat deel van het jaar. De privékilometers over deze periode worden dan omgerekend naar
                kilometers op jaarbasis.
                <div class="space10"></div>
                <u>Voorbeeld 1</u><br/>
                Je hebt van 1 oktober tot en met 31 december een auto van de onderneming met een catalogusprijs van €
                20.000. Je rijdt in die periode 100 kilometer privé met de auto. Je beschikt in het hele jaar dus 92
                dagen over de auto. Omgerekend naar een heel jaar zou je 365/92 x 100 = 396 kilometer privé rijden.
                Omdat je op jaarbasis niet meer dan 500 kilometer privé rijdt, is de bijtelling € 0. Kun je niet
                aantonen dat je op jaarbasis niet meer dan 500 kilometer hebt gereden? Dan geldt de bijtelling.
                <div class="space10"></div>

                <u>Voorbeeld 2</u><br/>
                Je hebt van 1 oktober tot en met 31 december een auto van je onderneming met een catalogusprijs van €
                20.000. Je rijdt in die periode 200 kilometer privé met de auto. Je beschikt in het hele jaar dus 92
                dagen over de auto. Omgerekend naar een heel jaar zou je 365/92 x 200 = 793 kilometer privé rijden. Het
                bedrag dat wordt bijgeteld, is op jaarbasis minimaal 22,00% van € 20.000 = € 4.400. Voor 92 dagen is dat
                dus
                92/365 x € 4.400 = € 1.109.
                <div class="space10"></div>

                <b>Deel van het jaar een andere auto</b><br/>
                Krijg je in de loop van het jaar een andere auto van de onderneming? Dan is de bijtelling alleen € 0 als
                je op jaarbasis met de auto's in totaal niet meer dan 500 kilometer privé rijdt.
                <div class="space10"></div>

                <b>Meer dan 1 auto tegelijkertijd</b><br/>
                Heb je tegelijkertijd meer dan 1 auto van de onderneming? Dan beoordeel je het privégebruik per auto.
                De bijtelling is alleen € 0 als je op jaarbasis met de auto's in totaal niet meer dan 500 kilometer
                privé
                rijdt.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Onttrekking privégebruik auto - invullen in SnelStart Fiscaal
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Belangrijk! In SnelStart Fiscaal moet je naast de gegevens van de auto ook de bijtelling
                    wegens privégebruik berekenen en invullen. <br/>
                    Vul altijd alle velden in, ook als er geen bijtellingsbedrag berekend wordt!</b>
                <div class="space10"></div>
                In de aangifte vind je de volgende velden:
                <div class="space10"></div>

                <b>Kenteken</b><br/>
                Het kenteken van de auto die ook voor privé-doeleinden ter beschikking is gesteld. Met een auto wordt
                een personenauto en een bestelauto bedoeld.
                <br/>
                <u>Koppeling RDW</u><br/>
                Door een koppeling met de openbare autogegevens van Rijksdienst Wegverkeer (RDW) worden de fiscale
                gegevens (cataloguswaarde, bijtellingspercentage etc.) verwerkt in de aangifte. Aan de hand van deze
                gegevens berekent SnelStart Fiscaal de bijtelling.<br/>
                Zelf kijken bij het RDW: check de <a href="https://ovi.rdw.nl/" target="_blank">RDW-website</a>.
                <div class="space10"></div>

                <b>Meer dan 500 km privé</b><br/>
                Vul 'Ja' in als er een auto's ten behoeve van de onderneming wordt gebruikt, ook voor
                privédoeleinden ter beschikking is gesteld. Het gaat dus om een auto’s die in de onderneming
                wordt gebruikt en waarvoor de onderneming de lasten draagt. De auto('s) wordt gehuurd, geleased of is in
                eigendom van de onderneming.<br/>
                Iedere personen- of bestelauto die in de onderneming aanwezig is als
                handelsvoorraad of als bedrijfsmiddel (inclusief lease of huur), en die door
                de ondernemer en zijn gezin voor privédoeleinden kan worden gebruikt
                komt in beginsel voor de autokostenfictie in aanmerking.<br/>
                Onder (bestel)auto wordt verstaan een auto die met rijbewijs B mag worden bestuurd. Voor motorfietsen,
                vrachtauto's en bussen geldt de forfaitaire bijtelling niet. Voor die motorvoertuigen wordt het voordeel
                van een eventueel privégebruik gesteld op de waarde in het economisch verkeer.
                <div class="space10"></div>

                <b>Km-administratie</b><br/>
                Het gaat om de vraag of een kilometeradministratie aanwezig is. Met een kilometeradministratie wordt ook
                bedoeld een rittenregistratie.
                <div class="space10"></div>

                <b>Cataloguswaarde</b><br/>
                Het gaat hier om de oorspronkelijke catalogusprijs van de ter beschikking gestelde auto met inbegrip van
                de omzetbelasting en de belasting van personenauto's en motorrijwielen. Is een auto meer dan 15 jaar
                geleden voor het eerst in gebruik genomen dan geldt de waarde in het economisch verkeer. Met een auto
                wordt een personenauto en een bestelauto bedoeld.
                <div class="space10"></div>

                <b>Begin- en einddatum</b><br/>
                Dit is de periode waarin de auto voor prive-doeleinden ter beschikking stond.
                <div class="space10"></div>

                <b>Privé betaald</b><br/>
                Vul het bedrag in dat de ondernemer terzake van de kosten en lasten van de auto voor
                eigen rekening heeft genomen (in privé betaald heeft).
                <div class="space10"></div>

                <b>Bedrag bijtelling</b><br/>
                Vul hier het berekende bedrag van de onttrekking in verband met privégebruik auto. De onttrekking wordt
                in aanmerking genomen voorzover zij uitgaat boven de bedragen die de belastingplichtige ter zake van de
                kosten en lasten van de auto voor eigen rekening heeft genomen. <br/>
                De bijtelling wegens privégebruik auto is niet hoger dan de autokosten (brandstofkosten, verzekering,
                afschrijving, onderhoudskosten etc.) die in dit jaar ten laste van de winst zijn gekomen. <br/>
                <div class="space10"></div>

                De berekening van bedrag privégebruik auto is als volgt:<br/>
                a) de catalogusprijs van de auto vermenigvuldigen met het percentage van de bijtelling. <br/>
                b) het resultaat a) te vermenigvuldigen met de verhouding van het aantal dagen in bezit en het totaal
                aantal kalenderdagen in een aangiftejaar.<br/>
                Het bedrag vermeld bij 'privé betaald' komt in mindering op de berekende bijtelling.

                <div class="space20"></div>

                <div *ngIf="this.year.valueOf() === 2024">
                    De percentages voor {{ this.year }} vind je onderstaand bij '6.4.1.2 Onttrekking privégebruik auto
                    van de onderneming'.
                    <div class="space10"></div>

                    <snelstart-ui-button size="small" type="secondary" iconRight="arrow-up-right-from-square">
                        <div>
                            <a target="_blank"
                               href="https://www.belastingdienst.nl/bibliotheek/handboeken/html/boeken/FISIN2024/fiscale_informatie_2024-winst_uit_onderneming.html#_a5c1308b-7404-4615-ac57-e8985d4b36de"
                            >
                                Informatie over privégebruik auto 2024
                            </a>
                        </div>
                    </snelstart-ui-button>
                </div>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Onttrekking overig
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Overige onttrekkingen zijn bijvoorbeeld de niet-zakelijke uitgaven die tot een verlaging van het
                ondernemingsvermogen
                hebben geleid. Je mag ze niet van de winst aftrekken, omdat het geen zakelijke uitgaven zijn.
                <div class="space10"></div>
                Maar het kunnen ook privéonttrekkingen in natura en in goederen zijn. Dit zijn uitgaven die uit het
                ondernemingsvermogen zijn betaald. Je mag ze niet van de winst aftrekken, omdat het geen zakelijke
                uitgaven zijn. Hieronder vallen bijvoorbeeld uitgaven voor het privégebruik van goederen of een telefoon
                van de onderneming.
            </div>
        </div>
    </div>


    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Storting overig
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Overige privéstortingen zijn ontvangsten die tot een verhoging van het ondernemingsvermogen leiden, maar
                die je niet tot de winst hoeft te rekenen, omdat het geen zakelijke inkomsten zijn.
                <div class="space10"></div>
                Het gaat bijvoorbeeld om:
                <li class="list">stortingen vanaf een privérekening</li>
                <li class="list">goederen die vanuit het privévermogen in de onderneming zijn ingebracht</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                Onttrekking privégebruik woning - invullen in SnelStart Fiscaal
            </button>
        </h2>
        <div id="collapse13" class="accordion-collapse collapse" aria-labelledby="heading13"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Vul altijd alle velden in,dus ook het te berekenen bedrag van de bijtelling!</b>
                <div class="space10"></div>
                Woonde de ondernemer in {{ this.year }} in een pand dat het hoofdverblijf was en dat volledig tot het
                ondernemingsvermogen behoorde? Dan moet je het woningforfait bij de winst tellen. Het woningforfait is
                een percentage van de WOZ-waarde van de woning.
                <div class="space10"></div>

                Het kan ook gaan om een pand dat de onderneming huurde en waarvan de ondernemer een deel als woning
                gebruikte.
                <div class="space10"></div>

                In de aangifte vind je de volgende velden:
                <div class="space10"></div>

                <b>Adresgegevens</b><br/>
                Dit betreft het adres van de woning in verband met de bijtelling privégebruik.
                <div class="space10"></div>

                <b>Woz-waarde</b><br/>
                De woningwaarde is de WOZ-waarde van het woongedeelte van het pand. Die kan staan op de WOZ-beschikking
                die de ondernemer begin {{ this.year }} heeft gekregen. Vraag anders bij de gemeente om de waarde te
                laten splitsen. Je mag dit ook laten taxeren.
                <div class="space10"></div>

                <b>% eigendom</b><br/>
                Is er sprake van eeen eenmanszaak? Dan is er normaal gesproken sprake van 100% gerechtigdheid.<br/>
                Is er een samenwerkingsverband en deelt de ondernem,er de woning met 1 of meer deelnemers aan dat
                samenwerkingsverband? Dan kan het percentage gerechtigdheid lager zijn. Dit is bijvoorbeeld zo bij een
                man-vrouwmaatschap. Bij een man-vrouwmaatschap is het percentage gerechtigdheid meestal 50% voor de ene
                en 50% voor de andere gerechtigde.
                <div class="space10"></div>

                <b>Begin- en einddatum</b><br/>
                Dit is de periode waarin de woning voor privégebruik ter beschikking stond.
                <div class="space10"></div>

                <b>Bedrag bijtelling</b><br/>
                Het bedrag van de onttrekking i.v.m. privégebruik woning.<br/>
                In een berekening wordt eerst het forfait over een volledig jaar berekend en
                vervolgens naar tijdsgelang omgerekend. Berekening van het forfait aan de hand van de woningwaarde van
                het hoofdverblijf en de tabel volgens de Wet IB2001, art 3.19.<br/>
                Vervolgens wordt deze uitkomst vermenigvuldigd met het percentage
                gerechtigdheid en vervolgens met de factor deel van het jaar. Het deel
                van het jaar is het aantal dagen van de beginperiode tot en met de
                eindperiode gedeeld door het aantal dagen in het jaar.<br/>
                Het resultaat wordt afgerond op hele euro's naar beneden.
                <div class="space10"></div>
                Indien er sprake is van een gebroken boekjaar, dan wordt de berekening
                2 maal uitgevoerd. De eerste berekening over het 1e deel van het
                boekjaar tot en met 31 december. De tweede berekening over het tweede
                deel van het boekjaar vanaf 1 januari tot einde boekjaar.
                <div class="space20"></div>

                <div *ngIf="this.year.valueOf() === 2024">
                    De percentages voor {{ this.year }} vind je onderstaand bij '6.4.1.2 Onttrekking privégebruik auto
                    van de onderneming'.
                    <div class="space10"></div>

                    <snelstart-ui-button size="small" type="secondary" iconRight="arrow-up-right-from-square">
                        <div>
                            <a target="_blank"
                               href="https://www.belastingdienst.nl/bibliotheek/handboeken/html/boeken/FISIN2024/fiscale_informatie_2024-winst_uit_onderneming.html#_a5c1308b-7404-4615-ac57-e8985d4b36de"
                            >
                                Informatie over privégebruik woning 2024
                            </a>
                        </div>
                    </snelstart-ui-button>
                </div>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Onttrekking privégebruik woning
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Woonde de ondernemer in {{ this.year }} in een pand dat het hoofdverblijf was en dat volledig tot het
                ondernemingsvermogen behoorde? Dan moet je het woningforfait bij de winst tellen. Het woningforfait is
                een percentage van de WOZ-waarde van de woning.
                <div class="space10"></div>

                Het kan ook gaan om een pand dat de onderneming huurde en waarvan de ondernemer een deel als woning
                gebruikte.
                <div class="space10"></div>

                <b>Onttrekking</b><br/>
                De onttrekking (het woningforfait) wordt berekend op basis van de 'Tabel woningforfait van de woning die
                tot het ondernemingsvermogen behoort'. Beschik je maar een deel van het jaar over de woning? Dan
                wordt een evenredig deel van het woningforfait over die periode berekend.
                <div class="space10"></div>

                <b>Woningwaarde</b><br/>
                De woningwaarde is de WOZ-waarde van het woongedeelte van het pand. Die kan staan op de WOZ-beschikking
                die de ondernemer begin {{ this.year }} heeft gekregen. Vraag anders bij de gemeente om de waarde te
                laten splitsen. Je mag dit ook laten taxeren.
                <div class="space10"></div>

                <b>Gerechtigdheid</b><br/>
                Is er sprake van eeen eenmanszaak? Dan is er normaal gesproken sprake van 100% gerechtigdheid.
                <div class="space10"></div>

                Is er een samenwerkingsverband en deelt de ondernemer de woning met 1 of meer deelnemers aan dat
                samenwerkingsverband? Dan kan het percentage gerechtigdheid lager zijn. Dit is bijvoorbeeld zo bij een
                man-vrouwmaatschap. Bij een man-vrouwmaatschap is het percentage gerechtigdheid meestal 50% voor de ene
                en 50% voor de andere gerechtigde.
                <div class="space10"></div>

                Meer informatie voor het jaar {{ this.year }} vind je onderstaand.
                <div class="space10"></div>

                <snelstart-ui-button size="small" type="secondary" iconRight="arrow-up-right-from-square">
                    <div>
                        <a target="_blank"
                           href="https://www.belastingdienst.nl/bibliotheek/handboeken/html/boeken/FISIN2024/fiscale_informatie_2024-winst_uit_onderneming.html#_a5c1308b-7404-4615-ac57-e8985d4b36de"
                        >
                            Informatie over privégebruik woning 2024
                        </a>
                    </div>
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Onttrekking onroerende zaak
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                In dit geval gaat het om een onroerende zaak welke vanuit de onderneming is overgebracht naar het
                privévermogen. Hoorde er een schuld bij deze onroerende zaak? Vermeld dan deze schuld in de aangifte als
                een overige privéstorting.
                <div class="space10"></div>
                Vul de waarde in het economisch verkeer in die de onroerende zaak had op het moment dat deze werd
                onttrokken. Het gaat om de waarde van het deel van de onroerende zaak dat op de
                balans van de onderneming staat.
                <div class="space10"></div>
                Vul de boekwaarde in die deze onroerende zaak had direct vóór het moment dat deze werd onttrokken of
                verkocht. Het gaat om de boekwaarde van het deel van de onroerende zaak dat op de balans van de
                onderneming staat.
            </div>
        </div>
    </div>


    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Storting onroerende zaak
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <div class="accordion-body">
                    In dit geval gaat het om een onroerende zaak welke vanuit privé is ingebracht in het
                    ondernemingsvermogen. Hoorde er een schuld bij deze onroerende zaak? Vermeld dan deze schuld in de
                    aangifte als een privéonttrekking in geld.
                    <div class="space10"></div>
                    Vul de waarde in het economisch verkeer in die de onroerende zaak had op het moment dat deze werd
                    ingebracht. Het gaat om de waarde van het deel van de onroerende zaak ingebracht wordt.
                </div>
            </div>
        </div>
    </div>

</div>

